// Hand-curated thematic groupings, orthogonal to JLPT level - a kanji can
// (and often does) belong to more than one category, e.g. 月/日 are both
// "days of the week" (Monday/Sunday) and "dates & time" (month/day). This is
// a first pass covering common beginner-relevant kanji, not an exhaustive
// classification of all ~2,900 jōyō + jinmeiyō kanji - extend the arrays
// below as more categories or coverage are needed.
export const kanjiCategoryDefinitions: { key: string; label: string; symbols: string[] }[] = [
    {
        key: "numbers",
        label: "Numbers",
        symbols: ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", "百", "千", "万", "億", "零"],
    },
    {
        key: "daysOfWeek",
        label: "Days of the Week",
        symbols: ["日", "月", "火", "水", "木", "金", "土", "曜"],
    },
    {
        key: "datesAndTime",
        label: "Dates & Time",
        symbols: [
            "年", "月", "日", "時", "分", "秒", "週", "間", "今", "朝", "昼", "夜", "午", "前", "後", "先", "来", "曜",
        ],
    },
    {
        key: "verbsActions",
        label: "Verbs & Actions",
        symbols: [
            "会", "行", "来", "帰", "見", "聞", "話", "言", "読", "書", "買", "売",
            "食", "飲", "作", "持", "待", "入", "出", "開", "閉", "立", "座", "歩",
            "走", "泳", "休", "働", "勉", "強", "習", "教", "起", "寝", "洗", "切",
            "貸", "送", "受", "乗", "降", "着", "脱", "消", "使", "死", "生", "活",
            "動", "止", "思", "知", "忘", "決", "選", "比", "違", "直",
        ],
    },
];

export const kanjiCategorySymbolSets: Record<string, Set<string>> = Object.fromEntries(
    kanjiCategoryDefinitions.map((category) => [category.key, new Set(category.symbols)])
);
